module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 168
// module chunks = 0 1 2 3 4 5 6 8 9 10 11 12